import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { SalesLayout } from "./layout";
import { Courtesies } from "./tabs/Courtesies";
import { Discounts } from "./tabs/Discounts";
import { Invoices } from "./tabs/Invoices";
import { Plans } from "./tabs/Plans";
import { Subscriptions } from "./tabs/Subscriptions";

export function Sales() {
	return (
		<Routes>
			<Route
				path="/"
				element={
					<SalesLayout>
						<Outlet />
					</SalesLayout>
				}
			>
				<Route path="planos" element={<Plans />} />
				<Route path="assinaturas" element={<Subscriptions />} />
				<Route path="cobrancas" element={<Invoices />} />
				<Route path="descontos" element={<Discounts />} />
				<Route path="cortesias" element={<Courtesies />} />
				<Route path="/" element={<Navigate to={"assinaturas"} replace />} />
			</Route>
		</Routes>
	);
}
